import { TherapeuticClass } from "src/app/ui/models/domains/pbm/Benefit/therapeutic-class";
import { AbstractParser } from "../../parser";
import { parseTherapeuticClass } from "./product-management-parse-funtions";

export class TherapeuticClassParser extends AbstractParser<TherapeuticClass> {
  public parse(payload: any): TherapeuticClass {
    return parseTherapeuticClass(payload);
  }
}
